import React, { FC } from 'react'

import { FiltersSharedProps } from '@new/__global/components/Filters/Filters.types'
import {
  RangeValuesFilter,
  RangeValuesProps,
} from '@new/__global/components/Filters/FiltersVariations/Range'
import { filtersLabels } from '@new/domains/bookings/screens/bookingsList/utils/labels'

interface GuestRangeFilterProps extends FiltersSharedProps {
  initialValue?: { from: string; to: string }
  onChange: (value?: { from?: string; to?: string }) => void
}

export const GuestsRangeFilter: FC<GuestRangeFilterProps> = ({
  initialValue,
  onChange,
  ...props
}) => {
  const handleGuestCountChange = ({ fromRangeValue, toRangeValue }: RangeValuesProps) => {
    onChange({ from: fromRangeValue, to: toRangeValue })
  }

  return (
    <RangeValuesFilter
      title={filtersLabels.guestsRange}
      fromInputTypeIndicator="Min"
      toInputTypeIndicator="Max"
      shouldDisplayFiltersOnSameLine
      onChange={handleGuestCountChange}
      rangeValues={{ fromRangeValue: initialValue?.from, toRangeValue: initialValue?.to }}
      placeholder={{ from: '', to: '' }}
      {...props}
    />
  )
}
